import React from 'react';
import PropTypes from 'prop-types';
import Sobre from './Sobre';
import Semblanzas from './Semblanzas';
import Creditos from './Creditos';
import Pelicula from './Pelicula';
import Exposicion from './Exposicion';
import './Content.css';

const Content = props => {
  const { content } = props;
  let contentComponent;
  switch (content) {
    case 'sobre':
      contentComponent = <Sobre />;
      break;
    case 'semblanzas':
      contentComponent = <Semblanzas />;
      break;
    case 'creditos':
      contentComponent = <Creditos />;
      break;
    case 'pelicula':
      contentComponent = <Pelicula />;
      break;
    case 'exposicion':
      contentComponent = <Exposicion />;
      break;
    default:
      break;
  }
  return <div className={`content-wrapper ${content}`}>{contentComponent}</div>;
};
export default Content;

Content.defaultProps = {
  content: '',
};

Content.propTypes = {
  content: PropTypes.string,
};
